import React from "react";
import { Button, Dialog } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NewPlanForm from "./NewPlanForm";
import { useSetRecoilState } from "recoil";
import { Plan } from "../../atom/atom";

function SimpleDialog(props) {
  const { onClose, open } = props;
  const setPlan = useSetRecoilState(Plan);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} hideBackdrop={true}>
      <NewPlanForm onClose={handleClose} setPlan={setPlan} />
    </Dialog>
  );
}

export default function CreateStyleButton(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={handleClickOpen}
        color="primary"
        size="medium"
        sx={{ fontWeight: "bold", height: "100%" }}
      >
        Add new analysis
      </Button>
      <SimpleDialog open={open} onClose={handleClose} />
    </React.Fragment>
  );
}
